<template>
	<div class="rounded-lg bg-white px-5 py-6 shadow sm:px-6">
		<slot />
	</div>
</template>
